import styled from "styled-components";
import COLORS from "shared/constants/colors";

const Container = styled.div`
  width: 100%;
  max-width: 100%;
  min-width: 0;
  padding: 0 20px 30px;
  overflow-x: clip;

  @media (max-width: 768px) {
    padding: 0 12px 20px;
  }
`;

const PageCard = styled.div`
  width: 100%;
  max-width: 100%;
  min-width: 0;
  background-color: ${COLORS.WHITE};
  border-radius: 8px;
  padding: 24px;
  margin-top: 10px;
  overflow-x: clip;

  @media (max-width: 768px) {
    padding: 16px;
    margin-top: 0;
    border-radius: 6px;
  }
`;

const PageLayout = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 20px;
  align-items: start;
  width: 100%;
  min-width: 0;

  @media (min-width: 1025px) {
    grid-template-columns: minmax(0, 420px) minmax(0, 1fr);
    gap: 28px;
  }
`;

const GalleryColumn = styled.div`
  position: static;
  min-width: 0;
  width: 100%;

  @media (min-width: 1025px) {
    position: sticky;
    top: 20px;
  }
`;

const ContentColumn = styled.div`
  min-width: 0;
  width: 100%;
`;

const GalleryWrapper = styled.div`
  width: 100%;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
  background: linear-gradient(135deg, #f9fafb 0%, #eef2f7 100%);
  box-shadow: 0 4px 20px rgba(21, 148, 219, 0.08);

  .slick-list {
    min-height: 360px;
  }

  .slick-dots {
    bottom: 12px;

    li button:before {
      font-size: 10px;
      color: ${COLORS.WHITE};
      opacity: 0.6;
    }

    li.slick-active button:before {
      opacity: 1;
    }
  }

  .slick-prev,
  .slick-next {
    z-index: 1;

    &:before {
      font-size: 32px;
      color: ${COLORS.WHITE};
    }
  }

  .slick-prev {
    left: 12px;
  }

  .slick-next {
    right: 12px;
  }

  @media (max-width: 768px) {
    .slick-list {
      min-height: 240px;
    }
  }
`;

const GallerySlide = styled.div`
  outline: none;
`;

const GalleryImage = styled.img`
  display: block;
  width: 100%;
  height: 360px;
  object-fit: cover;

  @media (max-width: 768px) {
    height: 240px;
  }
`;

const PricingLine = styled.p`
  margin: 0 0 20px;
  font-size: 15px;
  color: #4b5563;
  word-break: break-word;

  strong {
    color: ${COLORS.BLUE};
    font-family: "Inter600";
  }

  img {
    width: 18px;
    height: 12px;
    margin: 0 4px;
    vertical-align: middle;
  }
`;

const FeatureGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px 24px;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const FeatureItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: #18191f;
  font-family: "Inter500";

  svg {
    color: ${COLORS.BLUE};
    font-size: 22px;
  }
`;

const ModeTabs = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
  flex-wrap: wrap;
`;

const ModeTab = styled.button`
  border: 1px solid ${(props) => (props.$active ? COLORS.BLUE : "#e5e7eb")};
  background: ${(props) =>
    props.$active ? "rgba(21, 148, 219, 0.1)" : COLORS.WHITE};
  color: ${(props) => (props.$active ? COLORS.BLUE : "#4b5563")};
  border-radius: 6px;
  padding: 10px 16px;
  font-size: 14px;
  font-family: "Inter600";
  cursor: pointer;
  text-transform: none;
  transition: all 0.15s ease;

  &:hover {
    border-color: ${COLORS.BLUE};
    color: ${COLORS.BLUE};
  }
`;

const StepCard = styled.div`
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
  background: ${COLORS.WHITE};
`;

const StepTitle = styled.h3`
  margin: 0 0 12px;
  font-size: 16px;
  font-family: "Inter600";
  color: #18191f;
`;

const SheetSizeSelect = styled.select`
  width: 100%;
  max-width: 360px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 10px 12px;
  font-size: 14px;
  font-family: "Inter500";
  color: #18191f;
  background: ${COLORS.WHITE};
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: ${COLORS.BLUE};
  }
`;

const SheetPriceValue = styled.span`
  font-size: 22px;
  font-family: "Inter600";
  color: ${COLORS.BLUE};
`;

const BuilderLayout = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 250px) minmax(0, 1fr) minmax(0, 280px);
  gap: 24px;
  width: 100%;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;

const PropertiesPanel = styled.div`
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 280px;
  overflow: hidden;

  @media (max-width: 900px) {
    width: 100%;
  }
`;

const PropertiesEmptyState = styled.p`
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
  color: #64748b;
  font-family: "Inter500";
`;

const PropertiesTitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e2e8f0;
  padding-bottom: 12px;
  margin-bottom: 4px;

  h3 {
    font-size: 16px;
    font-family: "Inter700";
    color: #1e293b;
    margin: 0;
  }

  button {
    background: none;
    border: none;
    cursor: pointer;
    color: #64748b;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px;
    border-radius: 4px;

    &:hover {
      background: #f1f5f9;
      color: #334155;
    }
  }
`;

const PropertyGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  label {
    font-size: 13px;
    font-family: "Inter600";
    color: #475569;
  }

  input {
    width: 100%;
    padding: 8px 12px;
    border: 1px solid #cbd5e1;
    border-radius: 6px;
    font-size: 14px;
    font-family: "Inter500";
    color: #1e293b;
    box-sizing: border-box;

    &:focus {
      outline: none;
      border-color: ${COLORS.BLUE};
      box-shadow: 0 0 0 2px rgba(21, 148, 219, 0.1);
    }

    &:disabled {
      background: #f8fafc;
      color: #64748b;
      cursor: not-allowed;
    }
  }
`;

const PropertyRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
`;

const DpiIndicator = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 4px;

  .dpi-label {
    font-size: 13px;
    font-family: "Inter600";
    color: #475569;
  }

  .dpi-badge {
    padding: 8px 12px;
    border-radius: 6px;
    font-size: 13px;
    font-family: "Inter700";
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    width: 100%;
    
    &.low {
      background: #fef2f2;
      color: #dc2626;
      border: 1px solid #fecaca;
    }
    
    &.ok {
      background: #f0fdf4;
      color: #22c55e;
      border: 1px solid #dcfce7;
    }
    
    &.good {
      background: #f0fdf4;
      color: #166534;
      border: 1px solid #bbf7d0;
    }
  }
`;

const CheckoutControlsGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 6px 16px;
  box-sizing: border-box;

  @media (max-width: 600px) {
    flex-wrap: wrap;
    gap: 12px;
  }
`;

const VerticalDivider = styled.div`
  width: 1px;
  height: 24px;
  background-color: #e2e8f0;
  align-self: center;

  @media (max-width: 600px) {
    display: none;
  }
`;

const DesignPanel = styled.div`
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 16px;
  background: ${COLORS.WHITE};
  min-height: 280px;
  max-height: 600px;
  overflow: auto;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
`;

const DesignPanelTitle = styled.div`
  font-size: 13px;
  font-family: "Inter600";
  color: #374151;
  margin-bottom: 10px;
`;

const DesignThumbGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px 8px;
`;

const DesignThumbContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 4px;
`;

const DesignMetaText = styled.div`
  text-align: center;
  color: #374151;
  margin-top: 4px;
  width: 100%;
  overflow: hidden;

  .name {
    font-size: 12px;
    font-family: "Inter500";
    color: #4b5563;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
  }

  .dims {
    color: #1f2937;
    font-family: "Inter700";
    font-size: 11px;
    margin-top: 2px;
  }
`;

const DesignThumb = styled.button`
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: ${COLORS.WHITE};
  padding: 4px;
  cursor: pointer;
  aspect-ratio: 1;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  &:hover {
    border-color: ${COLORS.BLUE};
  }
`;

const CanvasShell = styled.div`
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #f8fafc;
  overflow: auto;
  max-height: 70vh;
  min-height: 380px;
  box-shadow: inset 0 2px 8px rgba(0, 0, 0, 0.04);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 24px;
  box-sizing: border-box;
`;

const CanvasInnerContainer = styled.div`
  width: ${(props) => props.$width}px;
  height: ${(props) => props.$height}px;
  flex-shrink: 0;
  position: relative;
  background-color: #ffffff;
  background-image: linear-gradient(45deg, #efefef 25%, transparent 25%, transparent 75%, #efefef 75%),
                    linear-gradient(45deg, #efefef 25%, #ffffff 25%, #ffffff 75%, #efefef 75%);
  background-size: 20px 20px;
  background-position: 0 0, 10px 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  border: 1px solid #cbd5e1;
`;

const CanvasInner = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  transform-origin: top left;
  transform: scale(${(props) => props.$zoom || 1});
`;

const Toolbar = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
  align-items: center;
`;

const ToolButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #e5e7eb;
  background: ${COLORS.WHITE};
  color: #374151;
  border-radius: 6px;
  padding: 7px 10px;
  font-size: 12px;
  font-family: "Inter500";
  cursor: pointer;

  &:hover:not(:disabled) {
    border-color: ${COLORS.BLUE};
    color: ${COLORS.BLUE};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  svg {
    font-size: 16px;
  }
`;

const WarningBanner = styled.div`
  margin: 8px 0 0;
  padding: 8px 12px;
  border-radius: 6px;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  color: #9a3412;
  font-size: 13px;
`;

const DropZone = styled.div`
  border: 2px dashed ${(props) => (props.$isDragging ? COLORS.BLUE : "#d1d5db")};
  border-radius: 8px;
  padding: 28px 16px;
  text-align: center;
  background: ${(props) =>
    props.$isDragging ? "rgba(21, 148, 219, 0.06)" : "#f9fafb"};
  cursor: pointer;
  transition: all 0.15s ease;
`;

const DropZoneTitle = styled.div`
  font-size: 15px;
  font-family: "Inter600";
  color: #18191f;
  margin-bottom: 4px;
`;

const DropZoneSubtitle = styled.div`
  font-size: 13px;
  color: #6b7280;
`;

const QuantityRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 12px;
  flex-wrap: wrap;
`;

const QuantityLabel = styled.label`
  font-size: 13px;
  font-family: "Inter500";
  color: #374151;
`;

const QuantityInput = styled.input`
  width: 80px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 8px 10px;
  font-size: 14px;

  &:focus {
    outline: none;
    border-color: ${COLORS.BLUE};
  }
`;

const OptionRow = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 12px;
  font-size: 14px;
  color: #374151;
  cursor: pointer;
`;

const CartActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 16px;
  flex-wrap: wrap;
`;

const CartSuccessMessage = styled.div`
  margin-top: 10px;
  font-size: 13px;
  color: ${(props) => (props.$error ? COLORS.RED : COLORS.GREEN)};
  font-family: "Inter500";
`;

const PreviewImageWrap = styled.div`
  margin-top: 12px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
  background: repeating-conic-gradient(#f3f4f6 0% 25%, #fff 0% 50%) 50% /
    16px 16px;
  max-height: 280px;

  img {
    display: block;
    width: 100%;
    max-height: 280px;
    object-fit: contain;
  }
`;

const FitcheckBackdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  z-index: 1300;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
`;

const FitcheckModal = styled.div`
  width: min(520px, 100%);
  background: ${COLORS.WHITE};
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.2);
`;

const FitcheckTitle = styled.h3`
  margin: 0 0 12px;
  font-size: 18px;
  font-family: "Inter600";
`;

const FitcheckApparelRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
`;

const FitcheckStage = styled.div`
  position: relative;
  height: 320px;
  border-radius: 10px;
  background: ${(props) => props.$color || "#f5f5f5"};
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

const FitcheckShirt = styled.div`
  width: 180px;
  height: 220px;
  border-radius: 12px 12px 24px 24px;
  background: ${(props) => props.$color || "#f5f5f5"};
  box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.08);
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  &::before,
  &::after {
    content: "";
    position: absolute;
    top: 28px;
    width: 48px;
    height: 70px;
    background: inherit;
    border-radius: 20px;
  }

  &::before {
    left: -36px;
    transform: rotate(25deg);
  }

  &::after {
    right: -36px;
    transform: rotate(-25deg);
  }

  img {
    position: relative;
    z-index: 1;
    max-width: 70%;
    max-height: 55%;
    object-fit: contain;
  }
`;

const HelpText = styled.p`
  margin: 8px 0 0;
  font-size: 12px;
  color: #6b7280;
`;

const SizeGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 12px;
  margin-top: 14px;
  margin-bottom: 8px;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  @media (max-width: 900px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  @media (max-width: 600px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

const SizeCard = styled.div`
  border: 2px solid ${props => props.$active ? COLORS.BLUE : '#e5e7eb'};
  background: ${props => props.$active ? `${COLORS.BLUE}08` : COLORS.WHITE};
  border-radius: 10px;
  padding: 14px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 8px;
  transition: all 0.2s ease-in-out;
  position: relative;
  overflow: hidden;

  &:hover {
    transform: translateY(-2px);
    border-color: ${props => props.$active ? COLORS.BLUE : '#cbd5e1'};
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.05);
  }
`;

const SizeCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 4px;
`;

const SizeCardLabel = styled.div`
  font-size: 15px;
  font-family: "Inter700";
  color: #1e293b;
`;

const SizeCardPrice = styled.div`
  font-size: 14px;
  font-family: "Inter600";
  color: ${COLORS.BLUE};
`;

const VisualBar = styled.div`
  height: 5px;
  background: ${props => props.$active ? COLORS.BLUE : '#e2e8f0'};
  border-radius: 3px;
  width: ${props => Math.max(10, Math.min(100, (props.$height / 200) * 100))}%;
  transition: all 0.3s ease;
`;

const ActiveCheck = styled.div`
  width: 18px;
  height: 18px;
  background: ${COLORS.BLUE};
  color: ${COLORS.WHITE};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

const CreateButton = styled.button`
  width: 100%;
  background: linear-gradient(135deg, ${COLORS.BLUE} 0%, #1081c0 100%);
  color: ${COLORS.WHITE};
  border: none;
  border-radius: 8px;
  padding: 14px 28px;
  font-size: 16px;
  font-family: "Inter700";
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 8px 20px -4px rgba(21, 148, 219, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 24px -4px rgba(21, 148, 219, 0.35);
    background: linear-gradient(135deg, #1081c0 0%, #0c6a9e 100%);
  }

  &:active {
    transform: translateY(0);
  }
`;

const QuantityRowCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  background: ${COLORS.WHITE};
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 16px 20px;
  margin-top: 18px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
`;

export {
  Container,
  PageCard,
  PageLayout,
  GalleryColumn,
  ContentColumn,
  GalleryWrapper,
  GallerySlide,
  GalleryImage,
  PricingLine,
  FeatureGrid,
  FeatureItem,
  ModeTabs,
  ModeTab,
  StepCard,
  StepTitle,
  SheetSizeSelect,
  SheetPriceValue,
  BuilderLayout,
  DesignPanel,
  DesignPanelTitle,
  DesignThumbGrid,
  DesignThumb,
  CanvasShell,
  CanvasInner,
  Toolbar,
  ToolButton,
  WarningBanner,
  DropZone,
  DropZoneTitle,
  DropZoneSubtitle,
  QuantityRow,
  QuantityLabel,
  QuantityInput,
  OptionRow,
  CartActions,
  CartSuccessMessage,
  PreviewImageWrap,
  FitcheckBackdrop,
  FitcheckModal,
  FitcheckTitle,
  FitcheckApparelRow,
  FitcheckStage,
  FitcheckShirt,
  HelpText,
  SizeGrid,
  SizeCard,
  SizeCardHeader,
  SizeCardLabel,
  SizeCardPrice,
  VisualBar,
  ActiveCheck,
  CreateButton,
  QuantityRowCard,
  CanvasInnerContainer,
  DesignThumbContainer,
  DesignMetaText,
  PropertiesPanel,
  PropertiesTitleRow,
  PropertiesEmptyState,
  PropertyGroup,
  PropertyRow,
  DpiIndicator,
  CheckoutControlsGroup,
  VerticalDivider,
};
